var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "detailBox" }, [
    _c(
      "div",
      {
        staticStyle: {
          position: "absolute",
          "z-index": "400",
          transform: "translate(-52%, -130%)",
        },
        style: {
          left: _vm.form.x + "px",
          top: _vm.form.y + "px",
        },
      },
      [
        _c("div", { staticClass: "warn" }, [
          _c("p", { staticStyle: { color: "#0ff", "font-size": "15px" } }, [
            _vm._v(_vm._s(_vm.form.param.name)),
          ]),
          _c("img", {
            staticClass: "close",
            attrs: { src: require("images/index/map/close.png") },
            on: { click: _vm.closeClick },
          }),
          _c("div", { staticClass: "flex contain" }, [
            _c("div", { staticClass: "leftBar" }),
            _c("div", { staticClass: "rightBar", staticStyle: { flex: "1" } }, [
              _c("div", { staticClass: "flex subCube" }, [
                _c("div", [
                  _c("p", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.form.param.area)),
                  ]),
                  _c("span", [_vm._v("土地面积（万亩）")]),
                ]),
                _c("div", [
                  _c("p", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.form.param.cl)),
                  ]),
                  _c("span", [_vm._v("产量（吨）")]),
                ]),
              ]),
              _c("div", { staticClass: "flex subCube" }, [
                _c("div", [
                  _c("p", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.form.param.cz)),
                  ]),
                  _c("span", [_vm._v("产值（万元）")]),
                ]),
                _c("div", [
                  _c("p", { staticClass: "num" }, [
                    _vm._v(_vm._s(_vm.form.param.lr)),
                  ]),
                  _c("span", [_vm._v("利润（万元）")]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }